export const ConsentAppPages = {
    CONSENT_HOME_PAGE: "CONSENT_HOME_PAGE",
    CONSENT_CONTENT_PAGE: "CONSENT_CONTENT_PAGE"
}

export const ConsentInfoScreens = {
    CONSENT_FORM_SCREEN: "CONSENT_FORM_SCREEN",
    CONSENT_RECORDED_SCREEN: "CONSENT_RECORDED_SCREEN",
    CONSENT_ALREADY_RECORDED_SCREEN: "CONSENT_ALREADY_RECORDED_SCREEN",
    CONSENT_LINK_EXPIRED_SCREEN: "CONSENT_LINK_EXPIRED_SCREEN",
    INCORRECT_USER_SCREEN: "INCORRECT_USER_SCREEN",
    GENERIC_ERROR_SCREEN: "GENERIC_ERROR_SCREEN"
}

export const ConsentTypes = {
    HOMES_WELCOME_CALL: "homes-welcome-call",
}

export const ConsentStatus = {
    ACTIVE: "ACTIVE",
    CANCELLED: "CANCELLED",
    EXPIRED: "EXPIRED",
    ANSWERED: "ANSWERED"
}

export const ConsentResponseStatus = {
    ACCEPTED: "ACCEPTED",
    REJECTED: "REJECTED",
    ALREADY_ANSWERED: "ALREADY_ANSWERED"
}